// Einstellungen → System, the first card (W20, W23 of APP-PARITY.md; until 23.10.2026 the page "Gerät" in Wartung):
// the device's figures as rows, the name at the left and the value at the right, the warnings after an update and
// "Neu starten". Board "System", decisions in core/screens/care.ts (deviceView).
import { deviceView } from '../../core/index.js';
import { Banner, Card } from '../components/index.js';
import { useMachine } from '../machine-context.js';
import { ActionButton } from '../tabs/parts.js';

/** the test IDs the lines had before they became a list (fw-version, uptime, device-wifi) */
const DEVICE_TEST_IDS = {
  fw: 'fw-version',
  uptime: 'uptime',
  lastStart: 'last-start',
  wifi: 'device-wifi',
} as const;

export function DeviceCard() {
  const { ctx } = useMachine();
  const d = deviceView(ctx);
  return (
    <Card className="tab-card" data-testid="device-card">
      <dl className="rows device-facts">
        {d.facts.map((f) => (
          <div key={f.key} className="row">
            <dt className="row-label">{f.label}</dt>
            <dd className="row-control" data-testid={DEVICE_TEST_IDS[f.key]}>
              {f.value}
            </dd>
          </div>
        ))}
      </dl>
      {d.pending && <Banner tone="warn">{d.pending}</Banner>}
      {d.rolledBack && (
        <Banner tone="warn" icon="alert" data-testid="fw-rolled-back">
          {d.rolledBack}
        </Banner>
      )}
      <ActionButton action={d.restart} size="md" block icon="restart" testId="restart" />
    </Card>
  );
}
